import { DashboardHeader } from '@modules/admin/Admin.Header'
import AccessControl from '@modules/auth/AccessControl'
import CustomModal from '@modules/core/components/CustomModalComponent'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { history as browserHistory } from '@services/History'

class SentenceShow extends Component {
  state = {
    id: this.props.match.params.sentenceId,
    deleteModal: false,
  }

  clientSentence = Consultations.sentence

  handleToggleModal = () => {
    this.setState((prevState) => ({ deleteModal: !prevState.deleteModal }))
  }

  handleDelete = () => {
    this.clientSentence
      .delete(this.state.id)
      .then(() => browserHistory.push('/sentence'))
      .catch((err) => window.alert(err.message))
  }

  componentDidMount() {
    return this.clientSentence
      .show(this.state.id)
      .then((res) => this.setState({ sentence: res.data }))
      .catch((err) =>
        this.setState(undefined, () => {
          throw err
        })
      )
  }

  render() {
    const { sentence, id } = this.state
    if (!sentence) return null
    return (
      <div className="crud-wrapper professional-wrapper">
        <div className="professional-show">
          <DashboardHeader title={<Trans>Frase Hecha</Trans>}>
            <AccessControl requiredPermission={sentence.is_editable}>
              <button className="btn btn-danger" onClick={() => this.handleToggleModal(this.state.deleteModal)}>
                <Trans>Borrar</Trans>
              </button>
              <Link className="btn btn-primary" to={`/sentence/update/${id}`}>
                <Trans>Editar</Trans>
              </Link>
            </AccessControl>
            <Link className="btn btn-primary" to={`/sentence`}>
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>
          {this.state.deleteModal && (
            <CustomModal
              title={<Trans>¿Estás seguro que quieres borrar este registro?</Trans>}
              active={this.state.deleteModal}
              actionOnClickClose={(active) => this.handleToggleModal(active)}
              actionOnClickAccept={(active) => this.handleDelete(active)}
            />
          )}
          <div className="container-fluid main-content">
            <div className="form-crud well">
              {sentence.string && (
                <div className="form-group">
                  <label>
                    <Trans>Frase</Trans>
                  </label>
                  <span>{sentence.string}</span>
                </div>
              )}
              <AccessControl>
                {sentence.companies && sentence.companies.length !== 0 && (
                  <div className="form-group">
                    <label>
                      <Trans>Compañías</Trans>
                    </label>
                    <span>
                      {sentence.companies
                        .map((company) => company.name)
                        .sort()
                        .join(', ')}
                    </span>
                  </div>
                )}
              </AccessControl>
              {sentence.specialities.length !== 0 && (
                <div className="form-group">
                  <label>
                    <Trans>Especialidades</Trans>
                  </label>
                  <span>
                    {sentence.specialities
                      .map((speciality) => speciality.name)
                      .sort()
                      .join(', ')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(SentenceShow)
